import React from 'react';

const Portfolio = () => {
  const projects = [
    { id: 1, title: 'Corporate Ecosystem', category: 'Web Development', img: 'https://images.unsplash.com/photo-1457305237443-44c3d5a30b89?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8d2ViJTIwZGV2ZWxvcG1lbnR8ZW58MHx8MHx8fDA%3D' },
    { id: 2, title: 'Analytics Dashboard', category: 'Desktop App', img: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800' },
    { id: 3, title: 'SEO Dominance', category: 'Search Strategy', img: 'https://images.unsplash.com/photo-1709281847981-73a69aa6f770?q=80&w=1632&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' },
    { id: 4, title: 'E-Commerce Core', category: 'Web Solutions', img: 'https://images.unsplash.com/photo-1557821552-17105176677c?w=800' },
  ];

  return (
    <section id="portfolio" className="py-20 md:py-32 bg-white">
      <div className="container mx-auto px-6 md:px-12">
        
        {/* Header Section - Responsive Flex */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12 md:mb-20 gap-6">
          <div className="max-w-xl">
            <span className="text-[#D62828] font-bold uppercase tracking-[0.4em] text-[10px] md:text-xs">Selected Works</span>
            <h2 className="text-4xl md:text-6xl font-black text-[#0A1D37] mt-3 uppercase tracking-tighter leading-none">
              The <span className="text-transparent" style={{ WebkitTextStroke: '1px #0A1D37' }}>Portfolio</span>
            </h2>
          </div>
          <p className="text-slate-500 font-medium max-w-sm text-sm md:text-base leading-relaxed">
            Delivering high-impact digital products that combine technical excellence with business strategy.
          </p>
        </div>

        {/* Portfolio Grid - Responsive Gaps */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12">
          {projects.map((project) => (
            <div key={project.id} className="group relative aspect-[16/10] overflow-hidden bg-[#0A1D37] cursor-pointer shadow-lg">
              
              {/* Image with Grayscale to Color transition */}
              <img 
                src={project.img} 
                alt={project.title}
                className="w-full h-full object-cover opacity-80 md:opacity-70 grayscale group-hover:grayscale-0 group-hover:opacity-40 group-hover:scale-105 transition-all duration-700 ease-in-out"
              />

              {/* Reveal Overlay - Adjusted for Mobile Visibility */}
              <div className="absolute inset-0 p-6 md:p-12 flex flex-col justify-end opacity-100 md:opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-t from-[#0A1D37]/90 via-transparent to-transparent md:from-transparent">
                
                {/* Decorative Line */}
                <div className="h-[2px] w-12 md:w-0 bg-[#D62828] group-hover:w-16 transition-all duration-700 delay-100 mb-4 md:mb-6"></div>
                
                <span className="text-[#D62828] font-bold uppercase tracking-[0.3em] text-[10px] mb-2 translate-y-0 md:translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                  {project.category}
                </span>
                
                <h3 className="text-white text-2xl md:text-4xl font-black uppercase tracking-tighter translate-y-0 md:translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-75 leading-tight">
                  {project.title}
                </h3>

                <div className="mt-4 md:mt-8 flex items-center space-x-3 text-white text-[10px] md:text-xs font-bold uppercase tracking-widest translate-y-0 md:translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-150">
                  <span>View Case Study</span>
                  <i className="fas fa-arrow-right text-[#D62828]"></i>
                </div>
              </div>

              {/* Minimalist Border Decoration - Hidden on mobile for cleaner look */}
              <div className="absolute top-0 right-0 w-0 h-0 border-t-2 border-r-2 border-[#D62828] group-hover:w-10 group-hover:h-10 transition-all duration-500 hidden md:block"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;